import { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useProfileQuery } from '../services/react-query/useProfileQuery'
import { normalFetch } from '../services/fetch-api/get'
import { useMainContext } from '../contexts/main'
import { useCreateTicketMutation, useTicketsQuery } from '../services/react-query/useTicketsQuery'
import {
	useCreateInviteCodeMutation,
	useDeleteInviteCodeMutation,
	useInviteCodesQuery,
	useInviteTreeQuery,
} from '../services/react-query/useInvitesQuery'
import { useBankCallbackQuery } from '../services/react-query/useBankCallbackQuery'

const useBankCallback = ({ trackId }) => {
	const {
		data: bankCallback,
		isFetching: bankCallbackLoading,
		refetch,
	} = useBankCallbackQuery({ trackId })

	useEffect(refetch, [trackId])

	return {
		bankCallback,
		bankCallbackLoading,
		refetch,
	}
}

export default useBankCallback
